import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgOutstream2 = (props) => /* @__PURE__ */ _jsx("svg", {
	viewBox: "0 0 16 16",
	xmlns: "http://www.w3.org/2000/svg",
	width: "1em",
	height: "1em",
	fill: "currentColor",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M2.46405 13.5366C2.69424 13.7668 2.97111 13.8819 3.29463 13.8819H12.7064C13.0299 13.8819 13.307 13.7668 13.5376 13.5366C13.7678 13.306 13.8829 13.029 13.8829 12.7054V3.29366C13.8829 2.97013 13.7678 2.69327 13.5376 2.46307C13.307 2.23248 13.0299 2.11719 12.7064 2.11719H3.29463C2.97111 2.11719 2.69424 2.23248 2.46405 2.46307C2.23346 2.69327 2.11816 2.97013 2.11816 3.29366V12.7054C2.11816 13.029 2.23346 13.306 2.46405 13.5366ZM12.7064 12.7054H3.29463V4.47013H12.7064V12.7054ZM6.23581 10.4378V6.73777C6.23581 6.54472 6.32409 6.39994 6.50064 6.30342C6.67719 6.20689 6.8509 6.21226 7.02175 6.3195L10.1143 8.1856C10.2737 8.28212 10.3535 8.41618 10.3535 8.58778C10.3535 8.75937 10.2737 8.89343 10.1143 8.98995L7.02175 10.856C6.8509 10.9633 6.67719 10.9687 6.50064 10.8721C6.32409 10.7756 6.23581 10.6308 6.23581 10.4378Z",
		fill: "white"
	})
});
export default SvgOutstream2;
